import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import { useYearContext } from "../components/YearContext";
import axios from "axios";
import { FaTrashAlt } from "react-icons/fa";
import {toast} from "react-toastify";
import Swal from "sweetalert2";


const Adminpayments = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [searchInput, setSearchInput] = useState(""); // Store search input
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetchinvoices();
  }, []);

  const fetchinvoices = async () => {
    try {
      const response = await axios.get("https://api.easytaxexperts.com/invoicespayment");

      if (response.data.success) {
        setInvoices(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

 
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`https://api.easytaxexperts.com/deleteinvoice/${id}`);
        if (response.data.success) {
          // Remove the deleted invoice from state
          setInvoices(prev => prev.filter(invoice => invoice.invoiceId !== id));
          
          // Show success message using toast
          toast.success("Invoice deleted successfully");
          
          // Optional: Show SweetAlert success (choose one method)
          // await Swal.fire({
          //   icon: "success",
          //   title: "Deleted!",
          //   text: "Invoice has been deleted successfully",
          //   timer: 1500,
          //   showConfirmButton: false,
          // });
        }
      } catch (error) {
        console.error("Error deleting invoice:", error);
        toast.error("There was an error deleting the invoice.");
      }
    }
  };
  
  const filterDocuments = invoices.filter((each) => {
    const documentDate = each.InvoiceDate ? each.InvoiceDate : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;
    const isSearchMatch =
      searchInput === "" ||
      each.userName.toLowerCase().includes(searchInput.toLowerCase()) ||
      each.phoneNumber.includes(searchInput) ||
      each.CallerName.toLowerCase().includes(searchInput.toLowerCase());

    return isYearMatch && isSearchMatch;
  });

  const reversedDocuments = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          
          
          <div className="col-lg-6 mb-3" >
                <input
                  type="text"
                     className="form-control form-control-sm"
                  placeholder="Search with client name, phonenumber, employee email"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  style={{ minWidth: "150px", height: "30px", padding: "5px" }}
                />
              </div>
            
            <div className="table-container"  style={{
    height: "calc(89vh - 150px)", // Adjust the 150px based on your header/pagination height
   
    border: "1px solid #ccc",
  }}>
            <div className="table-responsive tablediv">
            <table
      className="table table-hover table-bordered"
      style={{
        fontSize: "12px", // Smaller font size
        lineHeight: "1.2", // Reduce line height for compact view
      }}
    >
                <thead className="table-primary">
                  <tr>
                  <th style={{ padding: "5px" }}>S.No</th>
                  <th style={{ padding: "5px" }}>Invoice ID</th>
                  <th style={{ padding: "5px" }}>UserName</th>
                  <th style={{ padding: "5px" }}>Phone Number</th>
                  <th style={{ padding: "5px" }}>Email</th>
                  <th style={{ padding: "5px" }}>Invoice Date</th>
                  <th style={{ padding: "5px" }}>Services</th>
                  <th style={{ padding: "5px" }}>SSN</th>
                  {/* <th style={{ padding: "5px" }}>Caller Name</th> */}
                  <th style={{ padding: "5px" }}>Discount</th>
                  <th style={{ padding: "5px" }}>Referral</th>
                  <th style={{ padding: "5px" }}>Total Bill</th>
                  <th style={{ padding: "5px" }}>Payment Status</th>
                  <th style={{ padding: "5px" }}>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {records.map((each, index) => (
                    <tr key={index}>
                    <td style={{ padding: "5px" }}>{filterDocuments.length - ((currentPage - 1) * recordsPerPage + index)}</td>
                    <td style={{ padding: "5px" }}>{each.invoiceId}</td>
                    <td style={{ padding: "5px" }}>{each.userName}</td>
                    <td style={{ padding: "5px" }}>{each.phoneNumber}</td>
                    <td style={{ padding: "5px" }}>{each.email}</td>
                    <td style={{ padding: "5px" }}>{each.InvoiceDate}</td>
                      {/* <td>{each.Services}</td> */}
                      <td>
                      {each.Services ? (
                        Array.isArray(JSON.parse(each.Services)) &&
                        JSON.parse(each.Services).length > 0 ? (
                          JSON.parse(each.Services).map((record, index) => (
                            <ul key={index}>
                             <li>
            {record.service} - ${record.price}{" "}
            {record.state ? `(${record.state})` : ""}
          </li>
                            </ul>
                          ))
                        ) : (
                          <p>No records</p>
                        )
                      ) : (
                        <p>Loading...</p>
                      )}
                    </td>
                      <td>{each.SSN}</td>
                      {/* <td>{each.CallerName}</td> */}
                      <td>{each.Discount || 0}</td>
                      <td>{each.Referal || 0}</td>
                      <td>{each.totalBill}</td>
                      <td>{each.PaymentStatus}</td>
                      <td className="d-flex gap-1">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(each.invoiceId)}
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            </div>
            <nav className="mt-2">
            <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
                <li className="page-item">
                <a href="#" className="page-link" onClick={prePage}  style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }}>
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                     <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
                      >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                <a href="#" className="page-link" onClick={nextPage}
                  style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        
      
        </main>
      </div>
    </div>
  );
};

export default Adminpayments;
